module.exports = require("core-js-pure/features/object/create");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js/object/create.js
// module id = 499
// module chunks = 0 1